let task_list = []
export default {
    addTask(task) {
        task_list.push(task)
    },
    clearTask () {
        task_list = []
    },
    handleTask() {
        while (task_list.length) {
            task_list.pop()()
        }
    }
}
